import { NavLink } from "react-router-dom";
import Marker from "../assets/icons/marker";
import "../assets/styles/components/pv-card.scss";
import CheckRounded from "../assets/icons/check-rounded";
import CrownRounded from "../assets/icons/crown-rounded";
import Document from "../assets/icons/document";
import { setCookie } from "../utils/cookie";
import Profile from "../assets/icons/profile";
import PvStatsUsers from "./modal-contents/PvStatsUsers";

export default function PvCardStats({ state, context, pv_info }) {
  if (pv_info) {
    const sell_type = pv_info.pvAttributes.find(
      (x) => x.name.toUpperCase() === "MODALITA_VENDITA"
    ).value;

    //const appaltatori = pv_info.gestoreList.filter((x) => x.isAppaltatore);

    return (
      <div className="pv-card d-flex flex-column pt-3 overflow-hidden mb-3 mx-md-auto shadow-sm border">
        <div className="w-100 px-3">
          <small className="fw-bold me-2">Punto vendita:</small>
          <span>
            {`${pv_info.pv.codicePv} - ${pv_info.pv.codClasse} - 
          ${sell_type}`}
          </span>

          <div className="d-flex align-items-center  pt-3 py-2 my-2 border-bottom border-top">
            <Marker size={24} color="#eb831d" />
            <span className="ms-2">{`${pv_info.pv.indirizzo} (${pv_info.pv.cap}) ${pv_info.pv.comune} (${pv_info.pv.prov})`}</span>
          </div>
          <div className="pb-2 mb-3 border-bottom">
            <span>{pv_info.pv.codiceDistrict}</span>
            <strong className="mx-2">{">"}</strong>
            <span>{pv_info.pv.codiceArea}</span>
            <strong className="mx-2">{">"}</strong>
            <span>
              {pv_info.pv.nomeRcr} {pv_info.pv.cognomeRcr}
            </span>
          </div>

          {pv_info.gestoreList.length > 0 ? (
            <>
              <small className="fw-bold d-block">Gestore/i:</small>
              <ul className="ps-3 my-1">
                {pv_info.gestoreList.map((item, index) => {
                  return (
                    <li key={index}>
                      {item.ragioneSociale} ({item.tipoRelazione})
                    </li>
                  );
                })}
              </ul>
            </>
          ) : null}
        </div>
        <div className="border-top mt-3 d-flex align-items-center w-100 justify-content-center">
          <div
            onClick={() =>
              context.openModal(<PvStatsUsers pv={pv_info} />, false)
            }
            style={{ width: "calc(100%/4)", cursor: "pointer" }}
            className="text-decoration-none d-flex flex-column align-items-center p-2"
          >
            <div
              className="overflow-hidden d-flex align-items-center justify-content-center mb-1"
              style={{ width: 24, height: 24 }}
            >
              <Profile size={29} color="#20419a" />
            </div>

            <small style={{ fontSize: 11 }}>
              {pv_info.utentiList
                ? `${pv_info.utentiList.length} ${
                    pv_info.utentiList.length === 1 ? "Utente" : "Utenti"
                  }`
                : "0 Utenti"}
            </small>
          </div>
          <NavLink
            to="/check-list"
            state={state}
            style={{ width: "calc(100%/4)" }}
            className="text-decoration-none d-flex flex-column align-items-center p-2 border-start"
          >
            <div
              className="overflow-hidden d-flex align-items-center justify-content-center mb-1"
              style={{ width: 24, height: 24 }}
            >
              <CheckRounded size={29} color="#20419a" />
            </div>

            <small style={{ fontSize: 11 }}>Checklist</small>
          </NavLink>
          <NavLink
            to="/documents"
            state={state}
            style={{ width: "calc(100%/4)" }}
            className="text-decoration-none d-flex flex-column align-items-center mx-auto border-end border-start p-2"
          >
            <div
              className="overflow-hidden d-flex align-items-center justify-content-center mb-1"
              style={{ width: 24, height: 24 }}
            >
              <Document size={24} color="#20419a" />
            </div>
            <small style={{ fontSize: 11 }}>Documenti</small>
          </NavLink>
          <div
            onClick={() => {
              setCookie("pv_impersonate", pv_info.pv.codicePv);
              window.location.href = "/";
            }}
            style={{ width: "calc(100%/4)" }}
            className="text-decoration-none d-flex flex-column align-items-center p-2"
          >
            <div
              className="overflow-hidden d-flex align-items-center justify-content-center mb-1"
              style={{ width: 24, height: 24 }}
            >
              <CrownRounded size={22} color="#20419a" />
            </div>
            <small style={{ fontSize: 11 }}>Imperson..</small>
          </div>
        </div>
      </div>
    );
  }
}
